import { useState, useCallback } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useBoolean = /* @__PURE__ */ __name((initialState) => {
  const [value, setValue] = useState(initialState);
  const setFalse = useCallback(() => setValue(false), [setValue]);
  const setTrue = useCallback(() => setValue(true), [setValue]);
  const toggle = useCallback(() => setValue((prev) => !prev), [setValue]);
  return {
    setFalse,
    setTrue,
    setValue,
    toggle,
    value
  };
}, "useBoolean");

export { useBoolean };
//# sourceMappingURL=use-boolean.js.map
